import { render, staticRenderFns } from "./AnimatedEllipsis.vue?vue&type=template&id=7efd9396&scoped=true"
var script = {}
import style0 from "./AnimatedEllipsis.scss?vue&type=style&index=0&id=7efd9396&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efd9396",
  null
  
)

export default component.exports